import React from 'react';
import { observer } from 'mobx-react';

import { useCSVDownloader, jsonToCSV } from 'react-papaparse';

import './styles.css';
import { useStore } from 'utils/hooks/store';
import { CSVImportColumns } from 'utils/api/types';
import { ImportError } from 'stores/UserList/UserList';
import { importTemplateColumns } from 'utils/csv/importVocabulary';
import { UserRole } from 'core/constants';

type ErrorLogRow = Record<string, string>;

const DownloadErrors: React.FC = (): React.ReactElement => {
  const { CSVDownloader, Type } = useCSVDownloader();
  const { userList, session } = useStore();

  const { importVocabulary } = userList;

  const exportUsersToCSV = (data: ImportError[]): ErrorLogRow[] => {
    const userRoles: Record<string, string> = {
      user: 'user',
      manager: 'manager',
      account_owner: 'account owner',
    };

    const transformedData = data.map((user) => {
      const defaultUser: ErrorLogRow = {
        [CSVImportColumns.firstName]: user.firstName || '',
        [CSVImportColumns.lastName]: user.lastName || '',
        [CSVImportColumns.email]: user.email || '',
        [CSVImportColumns.role]: user.role ? userRoles[user.role] : '',
        [CSVImportColumns.dateOfBirth]: user.dateOfBirth || '',
        [CSVImportColumns.phoneNumber]: user.phoneNumber || '',
        [CSVImportColumns.teams]: user.teams && user.teams.length ? user.teams.join(',') : '',
        [CSVImportColumns.memorableWord]: user.memorableWord || '',
        [CSVImportColumns.loneWorkingLicense]: user.loneWorkingLicense ? 'True' : 'False',
        [CSVImportColumns.auditsLicense]: user.auditsLicense ? 'True' : 'False',
        [CSVImportColumns.eventsLicense]: user.eventsLicense ? 'True' : 'False',
        [CSVImportColumns.documentsLicense]: user.documentsLicense ? 'True' : 'False',
        [CSVImportColumns.alarmResponseProfile]: user.alarmResponseProfile || '',
        [CSVImportColumns.costCentre]: user.costCentre || '',
      };

      // The raw cell, not the resolved uuid: the operator fixes this file and uploads it again.
      importTemplateColumns(importVocabulary).forEach(({ key, header }) => {
        defaultUser[header] = user.source?.[key] || '';
      });

      if (session.user?.role === UserRole.Admin) {
        return { ...defaultUser, account: user.account || '', error: user.error };
      }
      return { ...defaultUser, error: user.error };
    });

    return transformedData;
  };

  return (
    <CSVDownloader
      className="csvDownloader"
      type={Type.Link}
      bom
      filename="error_log"
      delimiter=","
      data={jsonToCSV(exportUsersToCSV(userList.uploadErrors))}
    >
      Download Error Log (CSV)
    </CSVDownloader>
  );
};

export default observer(DownloadErrors);
